import Vue from 'vue'
import VueRouter from 'vue-router'
import { store } from '@/store'
import { authGuard, titleGuard, errorGuard } from './guards'

// 기능별 라우트 모듈
import mpcRoutes from './routes/mpc'
import platformRoutes from './routes/platform'
import settingsRoutes from './routes/settings'
import erc20Routes from './routes/erc20'
import erc721Routes from './routes/erc721'
import erc1155Routes from './routes/erc1155'
import arenaRoutes from './routes/arena'
import portalRoutes from './routes/portal'
import portalTokenRoutes from './routes/portalToken'
import portalLogRoutes from './routes/portalLog'
import aiAgentRoutes from './routes/aiAgent'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/metaplanet_lbank',
  },
  ...mpcRoutes,
  ...platformRoutes,
  ...settingsRoutes,
  ...erc20Routes,
  ...erc721Routes,
  ...erc1155Routes,
  ...arenaRoutes,
  ...portalRoutes,
  ...portalTokenRoutes,
  ...portalLogRoutes,
  ...aiAgentRoutes,
  // Test 라우트
  {
    path: '/testview',
    name: 'TestView',
    component: () =>
      import(/* webpackChunkName: "test" */ '@/views/Test/TestView.vue'),
    meta: { title: 'Test', group: 'test' },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

// 라우트 가드 적용
router.beforeEach(authGuard)
router.beforeEach(titleGuard)
router.beforeEach(errorGuard)

// 라우트 전환 시 에러 상태 초기화
router.afterEach(() => {
  store.commit('error/clearAllErrors')
})

export default router
